<pdf-viewer
  class="h-[1060px] mt-6"
  [src]="_src"
  [original-size]="true"
  [zoom-scale]="'page-height'"
  [autoresize]="true"
></pdf-viewer>
